import {ApiStatus} from 'commons/models/dtos/reports/ApiReport';
import {Documents, EfeResponse} from '../../commons/models';
import EfeApi from '../api/Api';
import {AxiosResponse} from 'axios';

async function generateContract(expedientId: number): Promise<EfeResponse<any>> {
    try {
        return await EfeApi.Reports.post<Documents>(
            `/api/v1/reports/clients/contract/${expedientId}`,
            {},
            {responseType: 'arraybuffer'},
        ).then((res: AxiosResponse<Documents>) => {
            return Promise.resolve({
                data: {data: res.data, filename: `Contract_${expedientId}.pdf`},
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}


async function validateContractService() {
    try {
        return await EfeApi.Reports.get<ApiStatus>('/api/v1/reports/app/info', {}
        ).then((res: AxiosResponse<ApiStatus>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    generateContract,
    validateContractService
};
